import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from '@/components/shadcn/tabs';
import PrivacyPolicy from '@/components/privacy/PrivacyPolicy';
import Overview from '@/components/privacy/Overview';
import RedactionRequest from '@/components/privacy/RedactionRequest';
import { P } from '@/components/shadcn/typography';
import Dropdown from '@/components/ui/common/Dropdown';
import Layout from '@/components/layout/Layout';

export enum privacyPage {
  overview = 'overview',
  // legalPlacards = 'legal-placards',
  privacyPolicy = 'privacy-policy',
  redactionRequest = 'redaction-request',
}

export type Menu = {
  [key in privacyPage]: {
    title: string;
    target: privacyPage;
  };
};

export const menu: Menu = {
  [privacyPage.overview]: {
    title: 'Overview',
    target: privacyPage.overview,
  },
  // [privacyPage.legalPlacards]: {
  //   title: 'Legal Placards',
  //   target: privacyPage.legalPlacards,
  // },
  [privacyPage.privacyPolicy]: {
    title: 'Privacy Policy',
    target: privacyPage.privacyPolicy,
  },
  [privacyPage.redactionRequest]: {
    title: 'Redaction Request',
    target: privacyPage.redactionRequest,
  },
};

export default function Index() {
  const router = useRouter();
  const {
    query: { id },
  } = router;

  const [activeTab, setActiveTab] = useState(privacyPage.overview);

  const page = Array.isArray(id) ? id[0] : id;

  useEffect(() => {
    const isValid = Object.values(privacyPage).some(
      validPage => validPage === page,
    );

    if (!isValid) {
      router.push('/privacy/overview', undefined, { shallow: true });
    }
  }, [page]);

  const handleTabChange = (tab: privacyPage) => {
    setActiveTab(tab);
  };

  return (
    <Layout gradientBg containerClassName="px-4 md:px-0">
      <div className="mb-6 mt-5 flex size-full flex-col gap-6 md:hidden">
        <P className="text-lg font-bold text-neutral-0">Privacy</P>
        <Dropdown
          variant="light"
          onChange={handleTabChange}
          value={activeTab}
          options={Object.values(menu).map(item => ({
            label: item.title,
            value: item.target,
          }))}
        />
      </div>
      <Tabs
        className="h-full w-full"
        onValueChange={value => handleTabChange(value as privacyPage)}
        value={activeTab}>
        <div className="z-40 hidden w-full items-center justify-center py-5 md:flex md:h-[80px]">
          <TabsList className="flex w-full max-w-[1100px] justify-between border-none bg-transparent p-0">
            <P className="font-bold text-neutral-0 md:text-xl">Privacy</P>
            {Object.values(menu).map(item => (
              <TabsTrigger
                className="bg-transparent text-base text-neutral-0 data-[state=active]:bg-transparent data-[state=active]:font-bold data-[state=active]:text-azure-700 data-[state=active]:shadow-none"
                value={item.target}
                key={item.target}
                onClick={() =>
                  router.push(item.target, undefined, { shallow: true })
                }>
                {item.title}
              </TabsTrigger>
            ))}
          </TabsList>
        </div>
        <div className="mx-auto flex size-full min-h-[calc(100vh-var(--header-height)-20rem)] max-w-[800px] pb-10">
          <TabsContent value={privacyPage.overview}>
            <div>
              <Overview />
            </div>
          </TabsContent>

          {/* <TabsContent value={privacyPage.legalPlacards}>
            <div></div>
          </TabsContent> */}

          <TabsContent value={privacyPage.privacyPolicy}>
            <div>
              <PrivacyPolicy />
            </div>
          </TabsContent>

          <TabsContent className="flex" value={privacyPage.redactionRequest}>
            <RedactionRequest />
          </TabsContent>
        </div>
      </Tabs>
    </Layout>
  );
}
